module.exports = __webpack_public_path__ + "static/media/back_arrow.206ce07c.svg";